import React from 'react';
import './DeleteAvatarForm.scss';

import {  closeDeleteAvatarForm } from './accountSlice';
import { deleteAvatar} from "../../Authorization/authSlice";

const DeleteAvatarForm = (props) => {
    const { dispatch } = props;
 // CLICK OK
 const onSend = () => {
        

    const item = {
        userId: props.user_id,
        imageName:props.avatar_name
    }
        console.log(item);
       dispatch(deleteAvatar(item));
       dispatch(closeDeleteAvatarForm());
    }


    // CLOSE FORM
    const onClose = () => {
        const { dispatch } = props;
       
    dispatch(closeDeleteAvatarForm());
    

    }


    const render = () => {
        //console.log(this.props.adminState.openInputForms);
       // this.props.accountState.openClearHistoryForm)
        if (true) {
            return(
                <div className="DeleteAvatarForm">
                    
                <p><b>Вы действительно хотите удалить аватар?</b></p>
                
                <button onClick={onSend}>Да</button>
                <button onClick={onClose}>Отмена</button>
                </div>
            )
        } else return null;
   
    }
return render();
}
export default DeleteAvatarForm;
  